import styled from "styled-components";
import { colors, devices, fonts } from "../../utils/styled/_variables.styled";

export const Section = styled.section`
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
	background-color: ${colors.bluegray};
	padding-top: 75px;
	padding-bottom: 75px;

	.case-study-editor-preview .image__content img{
		max-height: ${props => !props.isInEditor ? "80px" : "unset"};
	}

	@media ${devices.mobile} {
		padding-top: 45px;
		padding-bottom: 31px;
	}

	.heading_subtitle_container {
		margin-bottom: 20px;
		> div {
			margin-bottom: 0;
		}
	}

	.title_container {
		margin-bottom: 60px;
		@media ${devices.mobile} {
			margin-bottom: 48px;
		}
		> div {
			margin-bottom: 0;
		}
	}

	.case-study__container {
		width: 100%;

		.case-study-slider-container {
			width: 100%;
		}

		.case-study__header {
			display: flex;
			justify-content: flex-end;
			margin-bottom: 20px;
		}
	}

	.case-study-slider-container {
		width: 100%;
	}

	.case-study-editor-preview {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 32px;
		margin-top: 40px;
		margin-bottom: 50px;

		@media ${devices.tabletLarge} {
			grid-template-columns: 1fr;
		}
	}

	.slick-slider {
		width: 100%;

		.slick-list {
			overflow: visible;
		}
	}

	.slick-slider {
		width: 100%;

		.case-study-card{
			height: 450px;
		}


		.slick-dots {
			display: none !important;
		}

		.slick-list {
			overflow: visible;

			.slick-track {
				display: flex;
				justify-content: flex-start;
				flex-shrink: 0;

				& > * {
					margin-right: 32px;

					@media ${devices.tablets} {
						margin-right: 24px;
					}

					@media ${devices.mobile} {
						margin-right: 16px;
					}
				}

				& > *:last-child {
					margin-right: 0;
				}
			}
		}
	}

	hr {
		border: unset;

		@media ${devices.tabletLarge} {
			display: none;
		}
	}

	.rel-content__section__items {
		width: 100%;
		box-sizing: border-box;
		margin-top: 40px;
		overflow: visible;
		text-align: left;

		@media ${devices.mobile} {
			padding: 0 !important;
		}
	}

	.slick-list, .slick-track {
		text-align: left !important;
	}

	@media ${devices.mobile} {
		.slick-list {
			overflow: hidden;
		}
	}
`;

export const Headline = styled.div`
	p {
		font-size: 19px !important;
		font-family: ${fonts.AeonikMono};
		min-height: auto;
		line-height: 20px;
	}

	h1, h2, h3, h4, h5, h6 {
		font-size: 3.75rem;
		font-family: ${fonts.AeonikPro};

		@media ${devices.mobile} {
			font-size: 38px;
			font-weight: 500;
			line-height: 110%;
			letter-spacing: -0.77px;
		}
	}

	p,
	h1, h2, h3, h4, h5, h6 {
		color: white;
	}

	@media ${devices.tabletLarge} {
		margin-bottom: 40px;
	}

	@media ${devices.mobile} {
		margin-bottom: 32px;
		width: 100%;
		max-width: none;
		flex: 1 1 auto;
		padding: 0;
	}
`;

export const HeadingTitle = styled.div`
	margin-bottom: 8rem;
	flex: 1;
	@media ${devices.mobile} {
		margin-bottom: 140px;
	}
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	span {
		font-size: 20px;
		font-family: ${fonts.AeonikMono};

		@media ${devices.mobile} {
			font-size: 16.51px;
			font-weight: 400;
		}
	}
	p{
		font-size:19px!important;
	}

	@media ${devices.tabletLarge} {
		max-width: 100%;
	}
`;

export const Title = styled.div`
	margin-bottom: 30px;
	margin-top: auto;
	@media ${devices.mobile} {
		margin-bottom: 24px;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	span {
		color: ${colors.bluegray};
		font-size: 50px;
		font-weight: 400;
		font-family: ${fonts.AeonikPro};

		@media ${devices.mobile} {
			font-size: 41px;
		}
	}
	p{
		font-size:19px!important;
  }

	@media ${devices.tabletLarge} {
		max-width: 100%;
	}
`;

export const Subtitle = styled.div`
	margin-bottom: 32px;
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	span {
		color: ${colors.bluegray};
		font-family: ${fonts.AeonikPro};
		font-size: 20px;
		@media ${devices.mobile} {
			font-size: 16.51px;
		}
	}
	p{
		font-size:19px!important;
  }
`;

export const Button = styled.div`
	margin-bottom: 50px;

	@media ${devices.tabletLarge} {
		margin: 0;
	}

	section {
		justify-content: flex-start;
	}

	a, section a {
		background-color: ${colors.bluegray};
		color: white;
		padding: 10px 20px;
		border-radius: 30px;
		display: inline-block;
		text-decoration: none;
	}
`;

export const Logo = styled.div`
	margin-bottom: 24px;
	color: ${props => props.withFilter ? "#354153" : "transparent"};
	filter: ${props => props.withFilter ? "brightness(0) saturate(100%) invert(21%) sepia(6%) saturate(2725%)	hue-rotate(173deg) brightness(90%) contrast(84%)" : "unset"};

	section {
		min-height: unset;
		align-items: unset;
		display: inline;

		section.image__content {
			display: inline;
		}

		img {
			max-width: 250px;
			width: auto;
			height: auto;
		}
	}
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 600px;
	padding-top: 48px;
	padding-right: 40px;
	padding-left: 40px;
	background-color: ${colors.white};
	border-radius: 42px;
	color: ${colors.bluegray};

	@media ${devices.tabletLarge} {
		max-width: 100%;
		padding: 40px 24px;
		min-height: 500px;
	}

	@media ${devices.mobile} {
		padding: 39px 9px 40px 21px;
		min-height: auto;
		border-radius: 15px;
	}
`;

export const SliderArrows = styled.div`
	display: flex;
	gap: 16px;

	.arrow {
		width: 56px;
		height: 56px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		background-color: transparent;
		border-radius: 50%;
		transition: background-color 0.3s ease;

		&.disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		&:not(.disabled):hover {
			background-color: transparent;
		}

		&.prev {
			transform: rotate(180deg);
		}

		svg {
			width: 38px;
			height: 38px;
			transition: transform 0.2s ease;
			path {
				fill: ${colors.limeGreen};
			}
		}

		&:hover svg path {
			fill: ${colors.limeGreen};
		}
	}

	&.disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const SliderProgress = styled.div`
	width: 100%;
	height: 2px;
	background-color: rgba(255, 255, 255, 0.2);
	margin: 20px 0 40px;
	position: relative;

	&:after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: ${props => (props.currentSlide / Math.max(1, props.totalSlides - 4)) * 100}%;
		background-color: ${colors.limeGreen};
		transition: width 0.3s ease;
	}
`;

export const CaseStudyContainer = styled.div`
	display: flex !important;
	flex-direction: column !important;
	align-items: center !important;
	width: 100% !important;
	max-width: 1512px; !important;
	margin: 0 auto !important;
	padding: 0 !important;
`;

export const CaseStudySliderContainer = styled.div`

	.rel-content__section__header {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		width: 100%;
		margin-left: auto;
		margin-right: auto;
		box-sizing: border-box;
	}

	.rel-content__title-container {
		flex: 1;
	}

	.rel-content__subtitle,
	.rel-content__title__text {
		display: flex;
	}

	.rel-content__title__text h1,
	.rel-content__title__text h2,
	.rel-content__title__text h3,
	.rel-content__title__text h4,
	.rel-content__title__text h5,
	.rel-content__title__text h6 {
		font-size: 3.75rem;
		font-family: ${fonts.AeonikPro};
		color: white;

		@media ${devices.mobile} {
			font-size: 40px;
		}
	}

	@media ${devices.mobile} {
		.rel-content__title__text {
			padding-left: 0;
		}
	}

	.rel-content__subtitle p {
		font-size: 20px !important;
		font-family: ${fonts.AeonikMono};
		min-height: auto;
		line-height: 20px;
		color: white;
	}

	.rel-content__section__navigation {
		display: flex;
		gap: 16px;

		@media ${devices.mobile} {
			display: none;
		}
	}

	.rel-content__section__navigation__button {
		width: 56px;
		height: 56px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		background-color: transparent;
		border-radius: 50%;
		transition: background-color 0.3s ease;
	}

	.rel-content__section__navigation__button:not(.disabled):hover {
		background-color: transparent;
	}

	.rel-content__section__navigation__button:not(.disabled):hover svg path {
		stroke: ${colors.bluegray};
	}

	.rel-content__section__navigation__button svg {
		transform: rotate(180deg);
		background: transparent;
		width: 37px;
		height: 42px;
		transition: transform 0.2s ease;
	}

	.rel-content__section__navigation__button:first-child svg {
		transform: rotate(180deg);
	}

	.rel-content__section__navigation__button:last-child svg {
		transform: rotate(0deg);
	}

	.rel-content__section__navigation__button.disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.rel-content__section__navigation__button:hover svg path {
		fill: ${colors.limeGreen};
	}

	.rel-content__section__navigation__button svg path {
		fill: ${colors.limeGreen};
	}

	.rel-content__card--overlay__bgimg {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 30px;
	}

	.rel-content__card--overlay__bgimg img {
		max-width: 250px;
		max-height: 80px;
		width: auto;
		height: auto;
		object-fit: contain !important;
	}

	.slider__progress {
		margin-top: 30px;
		width: 100%;
		margin-left: auto;
		margin-right: auto;

		@media ${devices.mobile} {
			display: none;
		}
	}

	.slider__progress__wrapper {
		width: 100%;
		height: 2px;
		background-color: rgba(255, 255, 255, 0.2);
		margin-bottom: 40px;
		position: relative;
	}

	.slider__progress__marker {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		background-color: ${colors.limeGreen};
		transition: width 0.3s ease;
		margin-left: ${props => `${((1 / props.totalScrolls) * 100) * (props.currentSlide)}%`};
		width: ${props => `${(1 / props.totalScrolls) * 100}%`};
	}
`;

export const FullWidthSliderContainer = styled.div`
	width: 100%;
	padding: 0;
	margin: 0;
	box-sizing: border-box;
	position: relative;
	overflow: visible;
	display: flex;
	justify-content: flex-start;
`;

export const CaseStudyCardWrapper = styled.div`
	height: 450px;
	margin: 0;
	padding: 0 12px;
	box-sizing: border-box;

	@media ${devices.mobile} {
		padding: 0;
	}

	.case-study-card {
		background-color: white;
		border-radius: 15px;
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		position: relative;
		padding: 30px;
		overflow: hidden;
		transition: background-color 0.3s ease;
		box-sizing: border-box;

		&:hover {
			background-color: ${colors.limeGreen};
		}
	}

	.case-study-tag {
		font-family: ${fonts.AeonikMono};
		font-size: 14px;
		text-transform: uppercase;
		margin-bottom: 20px;
		color: ${colors.bluegray};
	}

	.case-study-image {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
		flex-grow: 1;
		transition: none;
		height: 200px;
		position: relative;
	}

	.case-study-card:hover .case-study-image {
		opacity: 0;
		visibility: hidden;
		position: absolute;
	}

	.case-study-hover-content {
		opacity: 0;
		transform: translateY(20px);
		transition: opacity 0.3s ease, transform 0.3s ease, height 0.3s ease;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: absolute;
		top: 80px;
		left: 30px;
		right: 30px;
		height: 0;
		overflow: hidden;
	}

	.case-study-card:hover .case-study-hover-content {
		opacity: 1;
		transform: translateY(0);
		position: relative;
		top: auto;
		left: auto;
		right: auto;
		height: auto;
		flex: 1;
	}

	.case-study-title {
		margin-bottom: 10px;
		color: ${colors.bluegray};
	}

	.case-study-description {
		color: ${colors.bluegray};
		margin-bottom: 20px;
	}

	.case-study-button {
		margin-top: 20px;
		text-align: left;
		display: flex;
		justify-content: flex-start;
	}

	.rel-content__card--overlay__link,
	.case-study-button section {
		justify-content: flex-start !important;
		text-align: left !important;
		display: flex !important;
	}
`;
